<template>
  <div>
    <span id="loading" v-if="this.loading == true">
      <Loading />
    </span>

    <h1>CTT</h1>

    <div class="container">
      <h3>Lista de Envios Pendentes</h3>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">DATA</th>
            <th scope="col">Transportadora</th>
            <th scope="col">Encomenda</th>
            <th scope="col">Nº Envio</th>
            <th scope="col">
              Confirmar <br />
              <input type="checkbox" @change="checkedAll($event)" />
            </th>
            <th scope="col">Cancelar</th>
          </tr>
        </thead>
        <tbody
          v-for="shipment in cttShipments"
          :key="shipment.id"
          :class="{
            'table-success': isShipmentUsedInGmp(shipment),
          }"
        >
          <td>{{ shipment.date }}</td>
          <td>{{ shipment.shipping_company }}</td>
          <td>{{ shipment.order_id }}</td>
          <td>
            <label :for="shipment.id">{{ shipment.tracking_number }}</label>
          </td>
          <td>
            <input
              type="checkbox"
              :id="shipment.id"
              :value="{
                id: shipment.id,
                order_id: shipment.order_id,
                tracking: shipment.tracking_number,
              }"
              v-model="checked"
            />
          </td>
          <td @click="deleteShipment(shipment.id, shipment.tracking_number)">
            ❌
          </td>
        </tbody>
      </table>
    </div>

    <h6><b>Total Encomendas: </b> {{ checked.length }}</h6>

    <div class="mb-2">
      <button
        class="btn btn-warning mr-2"
        @click="generateGmpFromAutomaticNormal()"
        :disabled="cttShipments.length === 0"
      >
        Gerar GMP Normal
      </button>
      <!-- Botão novo: gera GMP USA automaticamente -->
      <button
        class="btn btn-warning mr-2"
        @click="generateGmpFromAutomaticUsaLl()"
        :disabled="cttShipments.length === 0"
      >
        Gerar GMP USA
      </button>

      <!-- Botão antigo: fecho da guia CTT (abre modal) -->
      <button
        class="btn btn-primary"
        @click="handleCloseGuideClick()"
        :disabled="checked.length == 0"
      >
        Fechar Guia CTT
      </button>
    </div>

    <br />

    <b-modal
      ref="my-modal"
      id="my-modal"
      title="Lista de Encomendas para Fecho"
      size="xl"
      hide-footer
    >
      <b-table
        striped
        hover
        :items="cttOrdersClose"
        :fields="fields"
        thead-class="text-blue"
        class="table-orders"
      >
        <template #cell(name)="data">
          {{ data.item.first_name }} {{ data.item.second_name }}
        </template>
      </b-table>

      <div v-if="currentGmpData" class="mb-3">
        <hr />

        <h5>{{ currentGmpLabel }}</h5>

        <p class="mb-2">
          Identificador:
          <b>{{ currentGmpData.webGuideIdentifier }}</b>
        </p>

        <button class="btn btn-success" @click="openCurrentGmpFile()">
          Ver GMP
        </button>
      </div>

      <div class="mt-3">
        <button
          class="btn btn-primary btn-sm"
          v-b-modal.my-validation
          :disabled="hasCurrentGmpSelection && !currentGmpData"
        >
          Validar
        </button>
      </div>
    </b-modal>

    <b-modal
      ref="my-validation"
      id="my-validation"
      title="Dados da Guia CTT"
      size="sm"
      hide-footer
    >
      <form v-on:submit.prevent="cttClose()">
        <div class="form-group">
          <label for="numberInvoice">Nº Identificador de Guia</label>
          <input
            type="text"
            class="form-control"
            id="numberInvoice"
            v-model="numberInvoice"
            placeholder="Nº Identificador de Guia"
            :readonly="!!gmpCloseData"
            required
          />
        </div>
        <div>
          <button class="btn btn-primary" type="submit">Confirmar</button>
        </div>
      </form>
    </b-modal>

    <table class="table">
      <thead>
        <tr>
          <th scope="col">Transportadora</th>
          <th scope="col">Data</th>
          <th scope="col">Ficheiro</th>
          <th scope="col">GMP Normal</th>
          <th scope="col">GMP USA</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="close in allShipments" :key="close.id">
          <td>{{ close.shipping_company }}</td>
          <td>{{ calculateDate(close.date) }}</td>
          <td>
            <button class="btn btn-primary" @click="openFile(close.file)">
              Ver Ficheiro
            </button>
          </td>
          <td>
            <button
              v-if="close.gmp_type === 'normal' && close.gmp_label_ctt"
              class="btn btn-success"
              @click="openGmpFile(close.gmp_label_ctt)"
            >
              Ver GMP Normal
            </button>
            <span v-else>-</span>
          </td>

          <td>
            <button
              v-if="close.gmp_type === 'usa' && close.gmp_label_ctt"
              class="btn btn-success"
              @click="openGmpFile(close.gmp_label_ctt)"
            >
              Ver GMP USA
            </button>
            <span v-else>-</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loading from '@/components/Loading.vue';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      allShipments: [],
      loading: false,
      cttShipments: [],
      checked: [],
      cttFile: [],
      cttData: [],
      cttOrdersClose: [],
      numberInvoice: '',
      gmpCloseData: null,
      gmpNormalCloseData: null,
      gmpCreating: false,
      fields: [
        {
          key: 'id',
          label: 'ID',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 13px ; background-color:rgb(255, 147, 147);vertical-align: middle',
        },
        {
          key: 'name',
          label: 'Nome',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 13px ; background-color:rgb(255, 147, 147);vertical-align: middle',
        },
        {
          key: 'adress1',
          label: 'Morada',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 13px ; background-color:rgb(255, 147, 147);vertical-align: middle',
        },
        {
          key: 'city',
          label: 'Cidade',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 13px ; background-color:rgb(255, 147, 147);vertical-align: middle',
        },
        {
          key: 'state',
          label: 'Estado',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 13px ; background-color:rgb(255, 147, 147);vertical-align: middle',
        },
        {
          key: 'postcode',
          label: 'CP',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 13px ; background-color:rgb(255, 147, 147);vertical-align: middle',
        },
        {
          key: 'country',
          label: 'País',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 13px ; background-color:rgb(255, 147, 147);vertical-align: middle',
        },
        {
          key: 'tracking_number',
          label: 'Tracking',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 13px ; background-color:rgb(255, 147, 147);vertical-align: middle',
        },
        {
          key: 'weight',
          label: 'Peso',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 13px ; background-color:rgb(255, 147, 147);vertical-align: middle',
        },
        {
          key: 'expedition_number',
          label: 'Nº Envio',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 13px ; background-color:rgb(255, 147, 147);vertical-align: middle',
        },
      ],
    };
  },
  methods: {
    async handleCloseGuideClick() {
      this.loading = true;

      try {
        const currentCheckedOrderIds = this.checked.map((shipment) =>
          String(shipment.order_id)
        );

        const usaOrdersUsed = (this.gmpCloseData?.ordersUsed || []).map(String);

        const normalOrdersUsed = (
          this.gmpNormalCloseData?.ordersUsed || []
        ).map(String);

        const isSameGmpSelection = (ordersUsed) =>
          ordersUsed.length > 0 &&
          ordersUsed.length === currentCheckedOrderIds.length &&
          ordersUsed.every((orderId) =>
            currentCheckedOrderIds.includes(orderId)
          );

        const matchesUsaGmp = isSameGmpSelection(usaOrdersUsed);
        const matchesNormalGmp = isSameGmpSelection(normalOrdersUsed);

        /*
      Se a seleção não for exatamente a seleção que saiu da GMP,
      trata-se de fecho manual: nenhum identificador GMP pode ser usado.
    */
        if (!matchesUsaGmp && !matchesNormalGmp) {
          this.numberInvoice = '';
        }

        await this.$store.dispatch('dataCttClose', {
          shipments: this.checked,
        });

        this.cttData = this.getcttDataClose;
        this.cttOrdersClose = this.getcttOrdersClose;

        /*
      Se a seleção corresponde a uma GMP já criada:
      - não gerar preview;
      - abre modal para permitir consultar a lista e validar;
      - numberInvoice já contém webGuideIdentifier.
    */
        if (matchesUsaGmp || matchesNormalGmp) {
          this.$refs['my-modal'].show();
          return;
        }

        /*
      Fecho manual antigo:
      - preview imediato;
      - guia "Só para teste" no backend;
      - mostra modal de lista;
      - operador introduz o identificador manual na validação final.
    */
        await this.$store.dispatch('getCTTFileToday', {
          shipments: this.checked,
          numberInvoice: undefined,
          gmpData: null,
        });

        this.cttFile = this.getCTTFileToday;

        const base64 = this.cttFile
          .replace(/^data:application\/pdf;base64,/i, '')
          .replace(/\s/g, '');

        const binaryString = window.atob(base64);
        const bytes = new Uint8Array(binaryString.length);

        for (let index = 0; index < binaryString.length; index++) {
          bytes[index] = binaryString.charCodeAt(index);
        }

        const pdfBlob = new Blob([bytes], {
          type: 'application/pdf',
        });

        const pdfUrl = window.URL.createObjectURL(pdfBlob);

        window.open(pdfUrl, '_blank');

        window.setTimeout(() => {
          window.URL.revokeObjectURL(pdfUrl);
        }, 60000);

        this.$refs['my-modal'].show();
      } catch (err) {
        this.$swal(
          'Erro',
          err.message || 'Erro ao preparar o fecho CTT.',
          'error'
        );
      } finally {
        this.loading = false;
      }
    },

    async cttClose() {
      this.loading = true;

      const currentCheckedOrderIds = this.checked.map((shipment) =>
        String(shipment.order_id)
      );

      const isSameGmpSelection = (ordersUsed = []) =>
        ordersUsed.length > 0 &&
        ordersUsed.length === currentCheckedOrderIds.length &&
        ordersUsed
          .map(String)
          .every((orderId) => currentCheckedOrderIds.includes(orderId));

      const matchesUsaGmp = isSameGmpSelection(this.gmpCloseData?.ordersUsed);

      const matchesNormalGmp = isSameGmpSelection(
        this.gmpNormalCloseData?.ordersUsed
      );

      const gmpData = matchesUsaGmp
        ? this.gmpCloseData
        : matchesNormalGmp
        ? this.gmpNormalCloseData
        : null;

      const gmpType = matchesUsaGmp
        ? 'usa'
        : matchesNormalGmp
        ? 'normal'
        : null;

      try {
        await this.$store.dispatch('getCTTFileToday', {
          shipments: this.checked,
          numberInvoice: this.numberInvoice,
          gmpData,
          gmpType,
        });

        this.cttFile = this.getCTTFileToday;

        const base64 = this.cttFile
          .replace(/^data:application\/pdf;base64,/i, '')
          .replace(/\s/g, '');

        const binaryString = window.atob(base64);
        const bytes = new Uint8Array(binaryString.length);

        for (let index = 0; index < binaryString.length; index++) {
          bytes[index] = binaryString.charCodeAt(index);
        }

        const pdfBlob = new Blob([bytes], {
          type: 'application/pdf',
        });

        const pdfUrl = window.URL.createObjectURL(pdfBlob);

        window.open(pdfUrl, '_blank');

        window.setTimeout(() => {
          window.URL.revokeObjectURL(pdfUrl);
        }, 60000);

        this.$refs['my-validation'].hide();
        this.$refs['my-modal'].hide();

        await this.allCTTShipments();
        await this.getAllClose();

        this.checked = [];
        this.numberInvoice = '';
        this.gmpCloseData = null;
        this.gmpNormalCloseData = null;
        this.cttData = [];
        this.cttOrdersClose = [];
      } catch (err) {
        this.$swal(
          'Erro',
          err.message || 'Erro ao fechar a guia CTT.',
          'error'
        );
      } finally {
        this.loading = false;
      }
    },

    async getAllClose() {
      this.loading = true;
      try {
        await this.$store.dispatch('allNCloseShipment');
        this.allShipments = this.getAllCTTClose;
      } catch (err) {
        alert(err);
      }
      this.loading = false;
    },

    openFile(file) {
      const base64 = file
        .replace(/^data:application\/pdf;base64,/i, '')
        .replace(/\s/g, '');

      const binaryString = window.atob(base64);
      const bytes = new Uint8Array(binaryString.length);

      for (let index = 0; index < binaryString.length; index++) {
        bytes[index] = binaryString.charCodeAt(index);
      }

      const pdfBlob = new Blob([bytes], {
        type: 'application/pdf',
      });

      const pdfUrl = window.URL.createObjectURL(pdfBlob);

      window.open(pdfUrl, '_blank');

      window.setTimeout(() => {
        window.URL.revokeObjectURL(pdfUrl);
      }, 60000);
    },

    openGmpFile(file) {
      if (!file) {
        alert('GMP USA não disponível para este fecho.');
        return;
      }

      const base64 = file
        .replace(/^data:application\/pdf;base64,/i, '')
        .replace(/\s/g, '');

      const binaryString = window.atob(base64);
      const bytes = new Uint8Array(binaryString.length);

      for (let index = 0; index < binaryString.length; index++) {
        bytes[index] = binaryString.charCodeAt(index);
      }

      const pdfBlob = new Blob([bytes], {
        type: 'application/pdf',
      });

      const pdfUrl = window.URL.createObjectURL(pdfBlob);

      window.open(pdfUrl, '_blank');

      window.setTimeout(() => {
        window.URL.revokeObjectURL(pdfUrl);
      }, 60000);
    },

    openGmpCloseFile() {
      if (!this.gmpCloseData?.guideDoc) {
        alert('GMP USA não disponível.');
        return;
      }

      const base64 = this.gmpCloseData.guideDoc
        .replace(/^data:application\/pdf;base64,/i, '')
        .replace(/\s/g, '');

      const binaryString = window.atob(base64);
      const bytes = new Uint8Array(binaryString.length);

      for (let index = 0; index < binaryString.length; index++) {
        bytes[index] = binaryString.charCodeAt(index);
      }

      const pdfBlob = new Blob([bytes], {
        type: 'application/pdf',
      });

      const pdfUrl = window.URL.createObjectURL(pdfBlob);

      window.open(pdfUrl, '_blank');

      window.setTimeout(() => {
        window.URL.revokeObjectURL(pdfUrl);
      }, 60000);
    },
    async generateGmpFromAutomaticNormal() {
      this.loading = true;

      // Este botão gera uma GMP separada, por isso limpa apenas
      // o estado da GMP normal e a seleção atual.
      this.gmpNormalCloseData = null;
      this.numberInvoice = '';
      this.checked = [];

      try {
        // Carrega dados completos de TODOS os CTT pendentes.
        // O backend filtra USA automaticamente.
        await this.$store.dispatch('dataCttClose', {
          shipments: this.cttShipments,
        });

        this.cttData = this.getcttDataClose;
        this.cttOrdersClose = this.getcttOrdersClose;

        const result = await this.$store.dispatch('createCloseDayGmpNormal', {
          orders: this.cttOrdersClose,
          observation: 'GMP Portugal e Internacional',
        });

        this.gmpNormalCloseData = result;

        // Este é o identificador da GMP normal e será usado no fecho.
        this.numberInvoice = result.webGuideIdentifier || '';

        const ordersUsedIds = result.ordersUsed || [];

        // Seleciona apenas shipments pertencentes à GMP normal.
        this.checked = this.cttShipments
          .filter((shipment) => ordersUsedIds.includes(shipment.order_id))
          .map((shipment) => ({
            id: shipment.id,
            order_id: shipment.order_id,
            tracking: shipment.tracking_number,
          }));

        this.$swal(
          'Completado',
          'GMP Portugal e Internacional criada com sucesso!',
          'success'
        );
      } catch (err) {
        this.gmpNormalCloseData = null;
        this.numberInvoice = '';
        this.checked = [];

        this.$swal(
          'Sem envios elegíveis',
          err.message ||
            'Não existem encomendas Portugal/internacionais não-USA para gerar GMP.',
          'info'
        );
      } finally {
        this.loading = false;
      }
    },

    async generateGmpFromAutomaticUsaLl() {
      this.loading = true;
      this.gmpCloseData = null;
      this.numberInvoice = '';
      this.checked = [];

      try {
        await this.$store.dispatch('dataCttClose', {
          shipments: this.cttShipments,
        });

        this.cttData = this.getcttDataClose;
        this.cttOrdersClose = this.getcttOrdersClose;

        const result = await this.$store.dispatch('createCloseDayGmpUsa', {
          orders: this.cttOrdersClose,
          observation: 'GMP EUA',
        });

        this.gmpCloseData = result;

        if (result.webGuideIdentifier) {
          this.numberInvoice = result.webGuideIdentifier;
        }

        const ordersUsedIds = result.ordersUsed || [];

        this.checked = this.cttShipments
          .filter((s) => ordersUsedIds.includes(s.order_id))
          .map((s) => ({
            id: s.id,
            order_id: s.order_id,
            tracking: s.tracking_number,
          }));

        this.$swal('Completado', 'GMP USA criada com sucesso!', 'success');
      } catch (err) {
        this.gmpCloseData = null;
        this.numberInvoice = '';
        this.checked = [];

        this.$swal(
          'Sem envios USA',
          err.message ||
            'Não existem encomendas USA com tracking LL para gerar GMP.',
          'info'
        );
      } finally {
        this.loading = false;
      }
    },

    calculateDate(date) {
      let newDate = new Date(date.split('T'));
      let year = newDate.getFullYear();
      let month = ('0' + (newDate.getMonth() + 1)).slice(-2);
      let day = ('0' + newDate.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },

    async allCTTShipments() {
      await this.$store.dispatch('allShipmentsCTT');
      this.cttShipments = this.getAllCTTShipments;
    },

    async deleteShipment(id, shipment) {
      this.$swal({
        title: 'Quer eliminar o envio ' + shipment + ' ?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, eliminar!',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true;
          try {
            await this.$store.dispatch('cttDeleteShipment', {
              id: id,
            });
            await this.allCTTShipments();
            this.$swal('Completado', 'Envio Eliminado!', 'success');
          } catch (err) {
            alert(err);
          } finally {
            this.loading = false;
          }
        }
      });
    },

    async checkedAll($event) {
      this.checked = $event.target.checked
        ? this.cttShipments.map((shipment) => ({
            id: shipment.id,
            order_id: shipment.order_id,
            tracking: shipment.tracking_number,
          }))
        : [];

      this.gmpCloseData = null;
      this.gmpNormalCloseData = null;
      this.numberInvoice = '';
    },

    hasUsaLlOrders(orders = []) {
      return orders.some(
        (o) =>
          String(o.country || '').toUpperCase() === 'US' &&
          String(o.tracking_number || '').startsWith('LL')
      );
    },

    isShipmentUsedInGmp(shipment) {
      const orderId = String(shipment.order_id);

      const usaOrdersUsed = (this.gmpCloseData?.ordersUsed || []).map(String);

      const normalOrdersUsed = (this.gmpNormalCloseData?.ordersUsed || []).map(
        String
      );

      return (
        usaOrdersUsed.includes(orderId) || normalOrdersUsed.includes(orderId)
      );
    },
    openCurrentGmpFile() {
      if (!this.currentGmpData?.guideDoc) {
        alert('GMP não disponível.');
        return;
      }

      const base64 = this.currentGmpData.guideDoc
        .replace(/^data:application\/pdf;base64,/i, '')
        .replace(/\s/g, '');

      const binaryString = window.atob(base64);
      const bytes = new Uint8Array(binaryString.length);

      for (let index = 0; index < binaryString.length; index++) {
        bytes[index] = binaryString.charCodeAt(index);
      }

      const pdfBlob = new Blob([bytes], {
        type: 'application/pdf',
      });

      const pdfUrl = window.URL.createObjectURL(pdfBlob);

      window.open(pdfUrl, '_blank');

      window.setTimeout(() => {
        window.URL.revokeObjectURL(pdfUrl);
      }, 60000);
    },
  },
  async created() {
    this.loading = true;
    await this.allCTTShipments();
    await this.getAllClose();
    this.loading = false;
  },
  computed: {
    ...mapGetters(['getAllCTTClose']),
    ...mapGetters(['getAllCTTShipments']),
    ...mapGetters(['getCTTFileToday']),
    ...mapGetters(['getcttOrdersClose']),
    ...mapGetters(['getcttDataClose']),

    hasUsaLlClose() {
      return this.hasUsaLlOrders(this.cttOrdersClose);
    },
    currentGmpData() {
      const currentCheckedOrderIds = this.checked.map((shipment) =>
        String(shipment.order_id)
      );

      const isSameGmpSelection = (ordersUsed = []) =>
        ordersUsed.length > 0 &&
        ordersUsed.length === currentCheckedOrderIds.length &&
        ordersUsed
          .map(String)
          .every((orderId) => currentCheckedOrderIds.includes(orderId));

      if (isSameGmpSelection(this.gmpCloseData?.ordersUsed)) {
        return this.gmpCloseData;
      }

      if (isSameGmpSelection(this.gmpNormalCloseData?.ordersUsed)) {
        return this.gmpNormalCloseData;
      }

      return null;
    },

    hasCurrentGmpSelection() {
      const currentCheckedOrderIds = this.checked.map((shipment) =>
        String(shipment.order_id)
      );

      const isSameGmpSelection = (ordersUsed = []) =>
        ordersUsed.length > 0 &&
        ordersUsed.length === currentCheckedOrderIds.length &&
        ordersUsed
          .map(String)
          .every((orderId) => currentCheckedOrderIds.includes(orderId));

      return (
        isSameGmpSelection(this.gmpCloseData?.ordersUsed) ||
        isSameGmpSelection(this.gmpNormalCloseData?.ordersUsed)
      );
    },

    currentGmpLabel() {
      if (this.currentGmpData === this.gmpCloseData) {
        return 'GMP USA';
      }

      if (this.currentGmpData === this.gmpNormalCloseData) {
        return 'GMP Portugal e Internacional';
      }

      return 'GMP';
    },
  },
};
</script>

<style scoped>
* {
  text-align: center;
}
.table-orders {
  font-size: 10px;
}
.table-success {
  background-color: #d4edda;
}
</style>
